import { composeClassNames } from "@faedev/editor-utils";
import { GetStaticProps } from "next";
import { useRouter } from "next/router";
import { Alert, Button } from "react-bootstrap";
import Content from "src/components/Content";
import Footer from "src/components/Footer";
import Footers from "src/components/Footers";
import Header from "src/components/Header";
import Headers from "src/components/Headers";
import InstructorList from "src/components/InstructorList";
import Page from "src/components/Page";
import Preloader from "src/components/Preloader";
import Translate from "src/components/Translate";
import constants from "src/constants";
import getDefaultOg from "src/functions/getDefaultOg";
import useGetDataInstructors, {
  getDataInstructors,
} from "src/functions/useGetDataInstructors";
import { sButton } from "src/styles/sButton.module.scss";
import { sPageInstructors } from "src/styles/sPageInstructors.module.scss";

export default function Profiles({ staticInstructors }) {
  const { locale: lang, push } = useRouter();

  //var dSortOptions = getSortOptions(`instructors`);
  //var dSelectedFilters = getSelectedFilters(`instructors`);

  const instructorsResult = useGetDataInstructors(lang);
  var dInstructorList = instructorsResult.data?.profiles || staticInstructors;

  return (
    <>
      <Headers data={getDefaultOg(lang)} />

      <Page
        className={composeClassNames([sPageInstructors, "page-instructors"])}
      >
        <Header />
        <Content fluid={`xxl`}>
          {/* {constants.Show.navSort || constants.Show.navFilter ? (
            <ListHeader
              sortOptions={dSortOptions}
              selectedFilters={dSelectedFilters}
            />
          ) : <div></div>} */}
          {instructorsResult.loading ? <Preloader /> : <div></div>}
          {instructorsResult.error && !instructorsResult.data ? (
            <Alert variant="danger">
              {String(instructorsResult.error.message)}
            </Alert>
          ) : (
            <div></div>
          )}
          {dInstructorList ? (
            <InstructorList
              cta={
                <Button
                  className={composeClassNames([sButton, "btn-cta"])}
                  onClick={() => push(constants.Paths.joinUs)}
                  type="button"
                  variant={`outline-primary`}
                >
                  <Translate tKey="Create a profile" />
                </Button>
              }
              data={dInstructorList}
              showMore={false}
              title={
                <Translate
                  tKey={`Profiles of yoga instructors, studios and festivals`}
                />
              }
            />
          ) : (
            <div></div>
          )}
        </Content>
        <Footer />
      </Page>
      <Footers />
    </>
  );
}

export const getStaticProps: GetStaticProps = async function () {
  const instructors = await getDataInstructors();

  return {
    props: {
      staticInstructors: instructors,
    },
    revalidate: constants.Intervals.default,
  };
};
